export default {"src":"/_next/static/media/dog_sledges.3565daea.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};